import { EndpointsExperiments } from './EndpointsExperiments';
import { EndpointsPrefilling } from './EndpointsPrefilling';
import { EndpointsSignupClient } from './EndpointsSignupClient';
import { EndpointsSignupCompleted } from './EndpointsSignupCompleted';
import { EndpointsStoreAcq143Treatment } from './EndpointsStoreAcq143Treatment';
import { EndpointsStoreCoac0001Treatment } from './EndpointsStoreCoac0001Treatment';
import { EndpointsGrowthSidePanelAcq143 } from './EndpointsGrowthSidePanelAcq143';
import { getFlowEndpointOverrides } from './getFlowEndpointOverrides';
import { EndpointsSignupInterest } from './EndpointsSignupInterest';
import { EndpointsEndOfSignup } from './EndpointsEndOfSignup';
import { EndpointsAuth } from './EndpointsAuth';
export const EndpointConfig = Object.assign({}, EndpointsAuth, EndpointsPrefilling, EndpointsSignupClient, EndpointsSignupCompleted, EndpointsStoreAcq143Treatment, EndpointsStoreCoac0001Treatment, EndpointsGrowthSidePanelAcq143, EndpointsEndOfSignup, EndpointsExperiments, getFlowEndpointOverrides(), EndpointsSignupInterest);
export const getEndpoint = endpointKey => EndpointConfig[endpointKey];
export const setEndpointFetched = endpointKey => {
  const endpoint = EndpointConfig[endpointKey];
  if (endpoint) {
    endpoint.fetched = true;
  }
};